"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ palette }) => ({
    base: {
        fontWeight: 200,
        padding: 3,
    },
    title: {
        padding: 3,
        fontSize: '25px',
        fontWeight: 400,
    },
    subTitle: {
        fontSize: '20px',
        fontWeight: 200,
        padding: 3,
    },
    bodyText: {
        padding: 3,
        fontWeight: 200,
        fontSize: '14px',
    },
    choiceTabs: {
        display: 'flex',
        flexDirection: 'row',
        height: 50,
        lineHeight: '50px',
        textAlign: 'center',
        marginTop: 10,
        marginBottom: 30,
    },
    tab: {
        flex: 1,
        borderColor: palette.classicGray,
        '&.unselected': {
            borderBottom: 'solid',
            background: palette.lightGray,
            borderBottomWidth: '1px',
        },
        '&.selected': {
            border: 'solid',
            borderBottom: 'none',
            borderWidth: '1px',
            background: 'cornflowerblue',
        },
    },
    stepBox: {
        flex: 1,
        paddingRight: 13,
    },
    stepHeading: {
        fontSize: '14px',
        fontWeight: 500,
    },
    stepDivider: {
        flex: 1,
        background: palette.pastelGrey,
        height: 1,
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: 14,
        marginRight: 14,
    },
    footer: {
        height: 50,
        marginTop: 30,
        marginBottom: 50,
    },
    vertBar: {
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '14px',
        width: 1,
        background: palette.classicGray,
        marginLeft: 15,
        marginRight: 15,
    },
    link: {
        cursor: 'pointer',
    },
    startClean: {
        padding: 10,
        textAlign: 'center',
        marginTop: 10,
    },
    setupWrapper: {
        height: '100%',
        display: 'flex',
    },
    mAuto: {
        margin: 'auto',
    },
    tabWrapper: {
        width: 891,
    },
    dInline: {
        display: 'inline',
    },
    platformImg: {
        marginRight: 10,
    },
    stepWrapper: {
        marginLeft: 15,
        width: 'auto',
    },
    stepSection: {
        marginLeft: 12,
        display: 'flex',
        flexDirection: 'row',
    },
    steps: {
        display: 'flex',
        flexDirection: 'row',
    },
    stepImg: {
        marginTop: 15,
    },
    divider: {
        marginBottom: 10,
    },
});
exports.styles = styles;
